import React from 'react';
import { FadeIn } from './ui/FadeIn';
export function HeroSection() {
  return <section className="relative pt-10 pb-6 overflow-hidden" style={{
    background: 'linear-gradient(180deg, var(--color-sky-light) 0%, var(--color-cream) 100%)'
  }} data-id="element-70">
      <div className="absolute top-0 left-0 w-full h-full pointer-events-none overflow-hidden" data-id="element-71">
        <div className="absolute top-[-15%] right-[-10%] w-[35%] h-[35%] rounded-full opacity-40 blur-3xl" style={{
        backgroundColor: 'var(--color-sky-mid)'
      }} data-id="element-72" />
        <div className="absolute bottom-[-10%] left-[-5%] w-[25%] h-[25%] rounded-full opacity-30 blur-3xl" style={{
        backgroundColor: 'var(--color-cream-warm)'
      }} data-id="element-73" />
      </div>

      <div className="container mx-auto px-4 relative z-10" data-id="element-74">
        <div className="max-w-5xl mx-auto text-center flex flex-col items-center" data-id="element-75">
          {/* Stars / social proof badge */}
          <FadeIn delay={0.05} data-id="element-76">
            <img src="https://cdn.magicpatterns.com/uploads/jtUjL2iSAzZimTv3YjW3ws/Diseno_sin_titulo.png" alt="Valoraciones de 5 estrellas" className="h-16 object-contain opacity-90 mb-3" data-id="element-77" />
          </FadeIn>

          {/* Title */}
          <FadeIn delay={0.15} data-id="element-78">
            <h1 className="md:text-5xl font-extrabold mb-4 max-w-3xl mx-auto text-[30px]" style={{
            color: 'var(--color-deep-blue)'
          }} data-id="element-79">
              Una colección cristiana para acercar a los niños a Dios
            </h1>
          </FadeIn>

          {/* Subtitle */}
          <FadeIn delay={0.25} data-id="element-80">
            <p className="text-lg md:text-xl leading-relaxed mb-6 max-w-2xl mx-auto" style={{
            color: 'var(--color-body)'
          }} data-id="element-81">
              Incluye 500 parábolas para niños con enseñanzas y preguntas,
              organizadas en distintas temáticas para acompañar diferentes
              momentos de la infancia con reflexiones.
            </p>
          </FadeIn>

          {/* Main mockup image with premium glow */}
          <FadeIn delay={0.3} className="w-full" data-id="element-82">
            <div className="relative max-w-3xl w-full mx-auto mb-8" data-id="element-83">
              <div className="absolute inset-0 rounded-full blur-3xl opacity-30 scale-105" style={{
              backgroundColor: 'var(--color-gold)'
            }} data-id="element-84" />
              <img src="https://cdn.magicpatterns.com/uploads/ttVM6rGpKjWu244an5Xj1i/MOCK_UP.png" alt="Colección Pequeños Amigos de Dios - Vista completa" className="relative w-full h-auto rounded-2xl shadow-2xl" data-id="element-85" />
            </div>
          </FadeIn>

          {/* CTA & Trust Line */}
          <FadeIn delay={0.35} data-id="element-86">
            <a href="#coleccion" className="inline-flex items-center justify-center px-10 py-4 text-lg font-bold text-white rounded-full transition-all duration-300 hover:-translate-y-1" style={{
            backgroundColor: 'var(--color-gold)',
            boxShadow: '0 4px 20px rgba(201,150,59,0.4)'
          }} onMouseEnter={e => {
            e.currentTarget.style.backgroundColor = 'var(--color-gold-hover)';
            e.currentTarget.style.boxShadow = '0 6px 25px rgba(201,150,59,0.5)';
          }} onMouseLeave={e => {
            e.currentTarget.style.backgroundColor = 'var(--color-gold)';
            e.currentTarget.style.boxShadow = '0 4px 20px rgba(201,150,59,0.4)';
          }} data-id="element-87">
              DESCUBRIR LA COLECCIÓN
            </a>
            <p className="mt-3 font-medium text-[16px]" style={{
            color: 'var(--color-body)'
          }} data-id="element-88">
              Elegida por más de 400 familias
            </p>
          </FadeIn>
        </div>
      </div>
    </section>;
}